import { usePageHeader } from "@/components/layouts/lib/page-header";
import { ProformaQuickViewDialog } from "./proformas/components/ProformaQuickViewDialog";
import { ProformaStatsGrid } from "./proformas/components/ProformaStatsGrid";
import { ProformasContent } from "./proformas/components/ProformasContent";
import { ProformasPageIntro } from "./proformas/components/ProformasPageIntro";
import { ProformasToolbar } from "./proformas/components/ProformasToolbar";
import { PROFORMAS_PAGE_GUIDE, PROFORMAS_PAGE_TIP } from "./proformas/proforma.constants";
import { useProformasPageData } from "./proformas/hooks/useProformasPageData";
import { useProformasPageState } from "./proformas/hooks/useProformasPageState";

export default function ProformasPage() {
  usePageHeader({
    title: "Proformas",
    helpTopic: "documents",
    guide: {
      steps: PROFORMAS_PAGE_GUIDE,
      tip: PROFORMAS_PAGE_TIP,
    },
  });

  const pageState = useProformasPageState();
  const pageData = useProformasPageData({
    search: pageState.search,
    statusFilter: pageState.statusFilter,
  });

  return (
    <div>
      <ProformasPageIntro />
      <ProformaStatsGrid
        proformasCount={pageData.proformas.length}
        metrics={pageData.metrics}
        latest={pageData.latest}
        loading={pageData.isLoading}
      />
      <ProformasToolbar
        search={pageState.search}
        statusFilter={pageState.statusFilter}
        viewMode={pageState.viewMode}
        filteredCount={pageData.filteredProformas.length}
        totalCount={pageData.proformas.length}
        onSearchChange={pageState.setSearch}
        onStatusFilterChange={pageState.setStatusFilter}
        onViewModeChange={pageState.setViewMode}
        onResetFilters={pageState.resetFilters}
      />
      <ProformasContent
        proformas={pageData.filteredProformas}
        viewMode={pageState.viewMode}
        isLoading={pageData.isLoading}
        onSelect={pageState.setSelectedProforma}
      />
      <ProformaQuickViewDialog
        proforma={pageState.selectedProforma}
        onOpenChange={(open) => {
          if (!open) pageState.setSelectedProforma(null);
        }}
      />
    </div>
  );
}
